export const CLAIM_ATTACHMENT_TYPES = {
  '03': 'Report Justifying Treatment Beyond Utilization Guidelines',
  '04': 'Drugs Administered',
  '05': 'Treatment Diagnosis',
  '06': 'Initial Assessment',
  '07': 'Functional Goals',
  '08': 'Plan of Treatment',
  '09': 'Progress Report',
  '10': 'Continued Treatment',
  '11': 'Chemical Analysis',
  '13': 'Certified Test Report',
  '15': 'Justification for Admission',
  '21': 'Recovery Plan',
  A3: 'Allergies/Sensitivities Document',
  A4: 'Autopsy Report',
  AM: 'Ambulance Certification',
  AS: 'Admission Summary',
  B2: 'Prescription',
  B3: 'Physician Order',
  B4: 'Referral Form',
  BR: 'Benchmark Testing Results',
  BS: 'Baseline',
  BT: 'Blanket Test Results',
  CB: 'Chiropractic Justification',
  CK: 'Consent Form(s)',
  CT: 'Certification',
  D2: 'Drug Profile Document',
  DA: 'Dental Models',
  DB: 'Durable Medical Equipment Prescription',
  DG: 'Diagnostic Report',
  DJ: 'Discharge Monitoring Report',
  DS: 'Discharge Summary',
  EB: 'Explanation of Benefits',
  HC: 'Health Certificate',
  HR: 'Health Clinic Records',
  I5: 'Immunization Record',
  IR: 'State School Immunization Records',
  LA: 'Laboratory Results',
  M1: 'Medical Record Attachment',
  MT: 'Models',
  NN: 'Nursing Notes',
  OB: 'Operative Note',
  OC: 'Oxygen Content Averaging Report',
  OD: 'Orders and Treatments Document',
  OE: 'Objective Physical Examination Document',
  OX: 'Oxygen Therapy Certification',
  OZ: 'Support Data for Claim',
  P4: 'Pathology Report',
  P5: 'Patient Medical History Document',
  PE: 'Parenteral or Enteral Certification',
  PN: 'Physical Therapy Notes',
  PO: 'Prosthetics or Orthotic Certification',
  PQ: 'Paramedical Results',
  PY: 'Physician’s Report',
  PZ: 'Physical Therapy Certification',
  RB: 'Radiology Films',
  RR: 'Radiology Reports',
  RT: 'Report of Tests and Analysis Report',
  RX: 'Renewable Oxygen Content Averaging Report',
  SG: 'Symptoms Document',
  V5: 'Death Notification',
  XP: 'Photographs',
};

export const CLAIM_ATTACHMENT_TYPES_OPTIONS = Object.entries(CLAIM_ATTACHMENT_TYPES).map(
  ([key, value]) => ({
    value: key,
    text: `${key} - ${value}`,
  })
);
